import React, { Component } from 'react';

class Signup extends Component {
    render() {
        return (
            <div>
                <h1>Signup Page</h1>
                <p>This is the signup page. You can create a new account here.</p>
            </div>
        );
    }
}

export default Signup;